<!--
     <ExplorerDirectorySelect
       :dirs="[{dir1}, {dir2}, {dir3}]"
       :index="83"
       :selected="dir1.id"
       :clearable="true"
       @change="my_change_handler(dir_id, index)"
     />
-->

<template>
  <!-- Directory selectors -->
  <span style="display: inline-block" class="text-start">
    <v-select
      v-model="model"
      item-text="name"
      item-value="id"
      :label="props.label"
      single-line
      style="width: 200px"
      color="primary"
      :items="dirs"
      :clearable="clearable"
      @change="fire_change"
      :class="[props.class || 'qmkey-form-input', {'required':props.required}]"
      :placeholder="props.placeholder || props.label"
      dense
      :rules="rules"
      background-color="#f2f2f2"
    >

      <!-- Select template for the selected item on the box -->
      <template v-slot:selection="{ item }">
        <span class="qmkey-form-input">
          <v-icon :color="item.color">
            mdi-folder
          </v-icon>
          {{ item.name }}
        </span>
      </template>

      <!-- Select items -->
      <template v-slot:item="{ active, item, attrs, on }">
        <span v-on="on" v-bind="attrs" class="qmkey-form-input">
          <v-icon :color="item.color">
            mdi-folder
          </v-icon>
          {{ item.name }}
        </span>
      </template>

    </v-select>
  </span>
</template>


<style lang="scss">
 @import "@/sass/explorer.scss";
 @import '@/sass/modalform.scss';
</style>


<script>
 export default {
   name: "ExlporerDirectorySelect",

   props: [
     'dirs',
     'index',
     'selected',
     'clearable',
     'props',
   ],

   data: () => ({
     model: null,
     valid: true,
   }),

   mounted() {
     this.model = this.selected || null;
   },

   computed: {
     rules() {
       return [(value) => (
         !!value
         || !this.props.required
         || this.$vuetify.lang.translator('required_field')
       )];
     },
   },

   methods: {
     fire_change(dir_id) {
       this.$emit('change', dir_id, this.index);
     },

     validate() {
       // TODO: Show error message
       return this.valid;
     },

     error_state(ok) {
       this.valid = ok
     },
   },

   watch: {
     selected(dir_id) {
       this.model = dir_id;
     },
   },
 }
</script>
